import { ResourceDictionary } from "./Resources";

export const CzechResourcesDictionary: ResourceDictionary = {
  Routes: {
    Login: "prihlaseni",
    Employees: "sprava-kontaktu",
    EmployeeDetail: "detail",
    EmployeeEdit: "editace",
    EmployeeCreate: "vytvorit",
    Guidepost: "rozcestnik",
    Dashboard: "dashboard",
    Users: "uzivatele",
    UserDetail: "detail",
    Companies: "spolecnosti",
    CompanyDetail: "detail",
    CompanyEdit: "editace",
    CompanyCreate: "vytvorit",
    AccessRoles: "skupiny-prav",
    AccessRoleDetail: "detail",
    InvoiceItemCategories: "kategorie",
    InvoiceItemCategoryDetail: "detail",
    InvoiceItemCategoryCreate: "vytvorit",
    Error403: "403",
    Error404: "404",
  },
  Errors: {
    APIError: {
      503: "API není aktuálně dostupná. Prosím zopakujte zvolenou operaci znovu.",
      500: "Při vyhodnocování vašeho požadavku došlo k chybě. Prosím zopakujte zvolenou operaci znovu.",
    },
    ApplicationError: {
      Title: "Chyba 500,",
      Subtitle: "Tak toto se nepovedlo, ale někdo už určitě pracuje na opravě.",
    },
    Error404: {
      Title: "Chyba 404,",
      Subtitle: "Stránka nenalezena",
    },
    Error403: {
      Title: "Chyba 403,",
      Subtitle: "Na danou stránku nemáte práva",
    },
  },
  Login: {
    FormTitle: "Vítejte,",
    FormSubTitle: "Je před Vámi další krásný den, tak hurá na něj!",
    Login: {
      Label: "Login",
    },
    Password: {
      Label: "Heslo",
    },
    Submit: "Přihlásit",
    Error: {
      General: "Při přihlášení nastala chyba",
      InvalidLogin: "Login nebyl nalezen",
    },
  },
  Auth: {
    Google: {
      Button: "Přihlášení",
      Redirect: {
        Title: "Probíhá ověřování,",
        SubTitle: "Ještě chvilku a můžeš se pustit do práce!",
      },
    },
    Logout: "Odhlásit",
  },
  Dashboard: {
    Title: "Vítejte",
    Breadcrumb: {
      Title: "Dashboard",
    },
    Logout: "Odhlásit",
    Tickets: {
      Reminders: "Co Vás dnes čeká",
      Warnings: "Upozornění",
      Cancel: "Zrušit",
      Confirm: "Vyřešit",
      Resolved: "Vyřešeno",
      Subordinates: {
        Title: "Upozornění spolupracovníků",
      },
      FixUntil: {
        Label: "Napravit do:",
        Today: "Dnes",
        Tomorrow: "Zítra",
        Yesterday: "Včera",
        BeforeDays: "Před {{days}} dny",
        AfterFewDays: "Za {{days}} dny",
        AfterManyDays: "Za {{days}} dnů",
      },
      Modal: {
        Title: "Zrušení tiketu",
        Text: "Vyplňte prosím důvod pro zrušení tiketu",
        InputLabel: "Důvod zrušení",
        Error: "Není vyplněn důvod!",
        Close: "Zavřít",
        Confirm: "Potvrdit",
      },
    },
    RecentActivities: {
      Title: "Poslední aktivity",
      NoActivities: {
        Title: "Čeká na toho pravého!",
        Text:
          "Tento modul je ve fázi myšlenky a čeká na toho správného bouchače, který by jej přivedl k životu!",
      },
    },
  },
  Users: {
    Title: "Uživatelé",
    Breadcrumb: {
      Title: "Přehled uživatelů",
    },
    CheckboxIsActive: "Zobrazit pouze aktivní",
    Status: {
      Active: "Aktivní",
      InActive: "Neaktivní",
      None: "Vše",
    },
    List: {
      SearchBar: "Vyhledat uživatele...",
      Name: "Jméno a příjmení",
      Email: "Login",
      LastLoginDate: "Poslední přihlášení",
      Status: "Stav",
      Delete: {
        Success: "Uživatel byl úspěšně smazán",
        Fail: "Uživatele se nepodařilo smazat",
      },
    },
    Detail: {
      Title: "Editace",
      Breadcrumb: {
        Title: "Upravit",
      },
      LastLoginDate: {
        Title: "Poslední přihlášení",
      },
      Status: {
        Title: "Stav",
        IsActive: "Aktivní",
        InActive: "Neaktivní",
      },
      AccessRoles: {
        Title: "Práva",
      },
      Save: "Uložit",
      SaveSuccess: "Uživatel byl úspěšně uložen",
      SaveFail: "Při ukládání uživatele nastala chyba",
      BasicInfo: {
        Title: "Základní informace",
        FirstName: "Jméno",
        LastName: "Příjmení",
        Login: "Login (e-mail)",
        Status: "Stav",
      },
    },
  },
  Companies: {
    Title: "Společnosti",
    Customer: "Odběratel",
    Supplier: "Dodavatel",
    SelectBox: {
      None: "Vše",
      Customer: "Pouze odběratel",
      Supplier: "Pouze dodavatel",
      CustomerAndSupplier: "Odběratel a dodavatel",
    },
    List: {
      BtnCreate: {
        Title: "Nová společnost",
      },
      SearchBar: "Vyhledat společnost...",
      Name: "Název",
      Street: "Ulice a číslo",
      PostalCode: "PSČ",
      City: "Město",
      Role: "Role",
      LastUpdate: "Aktualizováno",
      Detail: {
        Tooltip: "Detail",
      },
      Edit: {
        Tooltip: "Upravit společnost",
      },
      Delete: {
        Tooltip: "Smazat společnost",
        ConfirmTitle: "Potrvzení",
        ConfirmText: "Nasledující společnost bude smazána:",
        Success: "Společnost byla úspěšně smazána",
        Fail: "Společnost se nepodařilo smazat",
      },
      Close: {
        Tooltip: "Zavřít",
      },
      Breadcrumb: {
        Title: "Přehled společností",
      },
    },
    Detail: {
      Title: "Obecné",
      Address: "Adresa",
      IdentificationNumber: "IČ",
      TaxIdentificationNumber: "DIČ",
      Role: "Role",
      Signature: "Podpis",
      Documents: {
        Title: "Důležité odkazy",
      },
      Breadcrumb: {
        Title: "Detail společnosti",
      },
    },
  },
  CompanyEdit: {
    Title: "Nastavení",
    NewCompany: "Nová společnost",
    Breadcrumb: {
      Title: "Upravit společnost",
    },
    Save: "Uložit",
    Name: {
      Label: "Jméno",
      Validation: "Zadejte jméno!",
    },
    IdentificationNumber: {
      Label: "IČ",
      Validation: {
        Required: "Zadejte IČ!",
        Regex: "Zadejte pouze čísla!",
        Max: "Maximum povolených čísel je 10!",
        Equals: "Zadané IČ už je používáno!",
      },
    },
    TaxIdentificationNumber: {
      Label: "DIČ",
      Validation: {
        Max: "Maximum povolených znaků je 16!",
      },
    },
    Street: {
      Label: "Ulice",
      Validation: "Zadejte ulici!",
    },
    StreetNo: {
      Label: "Číslo popisné",
      Validation: "Zadejte číslo popisné!",
    },
    PostalCode: {
      Label: "PSČ",
      Validation: "Zadejte PSČ!",
    },
    City: {
      Label: "Město",
      Validation: "Zadejte město!",
    },
    IsCustomer: {
      Label: "Odběratel",
    },
    IsSupplier: {
      Label: "Dodavatel",
    },
    Role: {
      Label: "Role",
    },
    Image: {
      Label: "Podpis",
      Validation: {
        FileExtension: "Obrázek musí být ve formátu png",
        MaxSize: "Maximalní povolená velikost souboru je 4MB!",
      },
      Input: {
        Label: "Vyberte soubor:",
        Selected: "Vybráno:",
      },
      Btn: {
        Select: "Vybrat",
        Delete: "Smazat",
      },
    },
    Documents: {
      Label: "Důležité odkazy",
    },
    SaveSuccess: "Společnost byla úspěšně uložena",
    SaveFail: "Společnost se nepodařilo uložit",
    ContactEdit: {
      NewContact: "Nový kontakt",
      FirstName: {
        Label: "Jméno",
        Validation: "Zadejte jméno",
      },
      LastName: {
        Label: "Příjmení",
        Validation: "Zadejte příjmení",
      },
      Email: {
        Label: "Email",
        Validation: "Zadejte email!",
        WrongFormat: "Není zadán validní email!",
      },
      Phone: {
        Label: "Telefon",
        Validation: "Zadejte telefon!",
        WrongFormat: "Není zadán validní telefon!",
      },
      ManDayCharge: {
        Label: "Sazba",
        Tooltip: "Pro externího pracovníka sazba v Kč/MD.",
      },
      Position: {
        Label: "Pozice",
        Validation: "Vyberte pozici",
      },

      Save: {
        Success: "Kontakt úspěšně uložen",
        Error: "Nastala chyba na serveru",
      },
    },
  },
  AccessRoles: {
    Title: "Skupiny práv",
    Breadcrumb: {
      Title: "Přehled rolí a práv",
    },
    List: {
      Name: "Název",
      Code: "Kód",
      SearchBar: "Vyhledat skupinu...",
      Delete: {
        Tooltip: "Smazat uživalete",
        ConfirmTitle: "Potrvzení",
        ConfirmText: "Nasledující uživatel bude smazán:",
      },
    },
    Detail: {
      Title: "Skupiny práv",
      Breadcrumb: {
        Title: "Upravit",
      },
      AccessRights: "Práva",
      SearchBar: "Vyhledat právo...",
      Save: "Uložit",
      SaveSuccess: "Skupina práv byl úspěšně uložen",
      SaveFail: "Při ukládání skupiny práv nastala chyba",
    },
  },
  Validation: {
    Required: "Pole je povinné",
    InvalidEmail: "Email není validní",
  },
  MenuItems: {
    Dashboard: "Dashboard",
    Guidepost: "Rozcestník",
  },
  Guidepost: {
    Title: "Rozcestník",
    Close: "Zavřít",
    Description: {
      Title: "Rozcestník,",
      Subtitle: "S čím ti můžu pomoct?",
    },
    Recent: "Poslední navštívené",
    External: "Externí aplikace",
  },
  HumanResources: {
    EmployeeList: {
      Title: "Kontakty",
      Breadcrumb: {
        Title: "Přehled kontaktů",
      },
    },
    Employees: {
      BtnCreate: {
        Title: "Nový člen",
      },
      Breadcrumb: {
        Title: "Kontakty",
      },
      CollapsingButton: "Skrýt všechny podřízené",
      ExpandButton: "Zobrazit všechny podřízené",
      Subsidiaries: {
        One: "podřízený",
        More: "podřízení",
        Many: "podřízených",
      },
      Row: {
        Name: "Jméno",
        Departments: "Oddělení",
        Position: "Interní pozice",
        DateUpdated: "Poslední aktualizace",
        Anniversary: "Blíží se výročí",
        Detail: "Detail",
      },
      Detail: {
        Title: "Informace",
        Breadcrumb: {
          Title: "Detail",
        },
        Edit: "Upravit kontakt",
        Delete: {
          Label: "Smazat kontakt",
          ConfirmTitle: "Potrvzení",
          ConfirmText: "Nasledující kontakt bude smazán:",
          Success: "Kontakt byl úspěšně smazán",
          Fail: "Kontakt se nepodařilo smazat",
        },
        Contact: "Kontakt",
        ContactType: "Typ kontaktu",
        Supervisor: "Kontaktní osoba",
        Anniversary: "Výročí",
        BirthDate: "Datum narození",
        Positions: "Pozice",
        Documents: {
          Title: "Dokumenty",
        },
        Departments: {
          Title: "Oddělení",
          History: "Historie",
        },
        Status: {
          Title: "Stav",
        },
      },
    },
    EmployeeEdit: {
      Title: "Editace",
      NewEmployee: "Nový kontakt",
      Breadcrumb: {
        Title: "Upravit",
      },
      Save: "Uložit",
      BasicInfo: "Základní informace",
      FirstName: {
        Label: "Jméno",
        Validation: "Zadejte jméno!",
      },
      LastName: {
        Label: "Příjmení",
        Validation: "Zadejte příjmení!",
      },
      Email: {
        Label: "Email",
        Validation: "Zadejte email!",
        WrongFormat: "Není zadán validní email!",
      },
      Phone: {
        Label: "Telefon",
        Validation: "Zadejte telefon!",
        WrongFormat: "Není zadán validní telefon!",
      },
      Positions: {
        Label: "Pozice",
        Validation: "Vyberte pozici!",
        DateFrom: "Platné od",
        DateTo: "do",
        Add: "Přidat",
        Remove: "Odstranit",
        PositionValidation: {
          Empty: "Zadejte pozici!",
          EqualsLastPosition: "Zvolená pozice je aktivní!",
        },
        DateFromValidation: "Zadejte platné od!",
      },
      Helpdesk: {
        Label: "Jira a Helpdesk",
        Checkbox: "Nezapisuje se Jira a Helpdesk",
      },
      CanShowTicketsForColleaguesFromOwnDepartments: {
        Label: "Dashboard",
        Checkbox: "Zobrazit upozornění za oddělení",
      },
      ManDayCharge: {
        Label: "Sazba",
        Validation: "Zadejte sazbu!",
      },
      Status: {
        Title: "Stav",
        Label: "Aktivní",
      },
      Company: {
        Label: "Společnost",
        Validation: "Zadejte společnost!",
      },
      ContractType: {
        Label: "Typ smlouvy",
        Employee: "Zaměstnanec",
        IndividualBusinessman: "OSVČ",
        ExternalSupplier: "Externí dodavatel",
      },
      AnniversaryDate: {
        Label: "Výroční pohovor",
      },
      BirthDate: {
        Label: "Datum narození",
      },
      Departments: {
        Label: "Oddělení",
        DateFrom: "Přidáno",
        Add: "Přidat",
        Remove: "Odstranit",
        Validation: "Zadejte oddělení!",
        ValidationWasAdded: "Toto oddělení je již přidáno!",
      },
      Supervisor: {
        Label: "Kontaktní osoba",
      },
      Documents: {
        Label: "Dokumenty",
      },
      SaveSuccess: "Kontakt byl úspěšně uložen",
      SaveFail: "Kontakt se nepodařilo uložit",
    },
  },
  InvoiceItemCategories: {
    Title: "Přehled kategorií",
    Breadcrumb: {
      Title: "Přehled kategorií",
    },
    List: {
      Name: "Název",
      Code: "Kód",
      ISCode: "Kód kategorie",
      Division: "Divize",
    },
    Detail: {
      TitleCreate: "Nová kategorie",
      TitleEdit: "Editace kategorie",
      BreadcrumbCreate: "Nová kategorie",
      BreadcrumbEdit: "Editace",
      Name: "Název",
      Code: "Kód kategorie",
      ISCode: "Kód kategorie",
      Division: "Divize",
      Save: "Uložit",
      SaveSuccess: "Kategorie byla úspěšně uložena",
      SaveFail: "Kategorii se nepodařilo uložit",
      BtnCreate: "Nová kategorie",
      Validation: {
        Required: "Pole je povinné",
        MaxLength: "Maximální délka je {{max}} znaků",
      },
    },
  },
  Settings: {
    Title: "Nastavení",
  },
  Common: {
    Create: "Vytvořit",
    Search: "Vyhledat",
    Save: "Uložit",
    Delete: "Smazat",
    Cancel: "Zrušit",
    Settings: "Nastavení",
    Yes: "Ano",
    No: "Ne",
    Autocomplete: {
      NoOptions: "Nenalezeno",
      Loading: "Vyhledávám...",
      Clear: "Smazat",
      Close: "Zavřít",
      Open: "Otevřít",
    },
    DatePicker: {
      MinDate: "Datum nemúže být menší než {{minDate}}",
    },
    App: {
      Name: "IBIS",
      SubTitle: "Interní systém společnosti Business Logic s.r.o.",
    },
    TablePagination: {
      BackButton: "Předcházejici strana",
      NextButton: "Další strana",
      RowsPerPage: "Počet záznamů:",
      DisplayedRows: "{{from}}-{{to}} z {{count}}",
    },
    ConfirmRedirect: {
      Title: "Změny nebudou uloženy",
      Close: "Zavřít",
      Success: "Pokračovat",
    },
    Column: {
      Detail: {
        Tooltip: "Detail",
      },
    },
    Documents: {
      Show: "Zobrazit Dokument",
      Add: "Přidat",
      Remove: "Odstranit",
      Name: {
        Label: "Zadejte Název souboru…",
        Validation: "Zadejte Název souboru!",
      },
      Url: {
        Label: "Zadejte link na drive…",
        Validation: "Zadejte link na drive!",
        NoDriveLink: "Link nesměřuje na Google Drive!",
      },
    },
  },
};
